import React, { memo } from 'react';
import TableHead from '../TableComponent/TableHead';
import TableBody from '../TableComponent/TableBody';
import { metaColumnsConfig } from '../TableConfig/metaColumnsConfig';
import { usePinnedColumns } from '../hooks/usePinnedColumns';
import styles from '../SplitScrollTable.module.scss';

interface MetaTableProps {
  data: any[];
  itemCount: number;
  hoveredRow: string | null;
  expandedRows: Set<string>;
  rowHoveredClass: string;
  onRowHover: (issueId: string) => void;
  onRowLeave: () => void;
  onToggleRow: (issueId: string) => void;
  isCollapsed: boolean;
  onTouchPadClick: (columnKey: string) => void;
  // Shared chunking state
  renderedChunks?: number;
  setRenderedChunks?: (value: number | ((prev: number) => number)) => void;
  isLoadingMore?: boolean;
  setIsLoadingMore?: (value: boolean) => void;
}

export const MetaTable: React.FC<MetaTableProps> = memo(
  ({
    data,
    itemCount,
    hoveredRow,
    expandedRows,
    rowHoveredClass,
    onRowHover,
    onRowLeave,
    onToggleRow,
    isCollapsed,
    onTouchPadClick,
    renderedChunks,
    setRenderedChunks,
    isLoadingMore,
    setIsLoadingMore
  }) => {
    // Get reordered columns based on pin selections
    const pinnedColumns = usePinnedColumns(metaColumnsConfig);

    const containerClass = isCollapsed
      ? `${styles.leftTableContainer} ${styles.collapsed}`
      : styles.leftTableContainer;

    return (
      <div className={containerClass}>
        <table className={styles.table}>
          <TableHead
            columns={pinnedColumns}
            itemCount={itemCount}
            onTouchPadClick={onTouchPadClick}
            metaTableCollapsed={isCollapsed}
          />
          <TableBody
            data={data}
            columnsConfig={pinnedColumns}
            type="meta"
            hoveredRow={hoveredRow}
            expandedRows={expandedRows}
            rowHoveredClass={rowHoveredClass}
            onRowHover={onRowHover}
            onRowLeave={onRowLeave}
            onToggleRow={onToggleRow}
            renderedChunks={renderedChunks}
            setRenderedChunks={setRenderedChunks}
            isLoadingMore={isLoadingMore}
            setIsLoadingMore={setIsLoadingMore}
          />
        </table>
      </div>
    );
  }
);

MetaTable.displayName = 'MetaTable';
